<template>
  <page-list :list="list" :columns="riCoverageDetailColumns" />
</template>

<script>
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import RiCoverageColumnsMixin from '../mixins/riCoverageColumns'

export default {
  name: 'RiCoverageSpecDetail',
  mixins: [ListMixin, WindowsMixin, RiCoverageColumnsMixin],
  props: {
    spec: {
      type: String,
      required: true,
    },
    cloudaccountId: {
      type: String,
      required: true,
    },
    dateParam: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      riCoverageHiddenFields: ['coverage'],
      list: this.$list.createList(this, {
        id: 'riCoverageSpecDetail',
        resource: 'bill_analysises/reservations',
        apiVersion: 'v1',
        getParams: this.getListParams,
        noPreLoad: true,
      }),
    }
  },
  watch: {
    dateParam: {
      handler () {
        this.fetchData()
      },
      deep: true,
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    getListParams () {
      return {
        cloudaccount_id: this.cloudaccountId,
        scope: this.$store.getters.scope,
        spec: this.spec,
        ...this.dateParam,
      }
    },
    fetchData () {
      this.list.fetchData()
    },
  },
}
</script>
